export default class FloatingTexts {
  private mAttachedScene: Phaser.Scene;

  /*
        Float duration (More will get higher)
    */
  FloatDurationMilliseconds: number;

  /*
   *  MS for fading out
   */
  FadeDurationMilliseconds: number;

  constructor(scene: Phaser.Scene) {
    this.mAttachedScene = scene;
  }

  AddText(
    text: string,
    x: number,
    y: number,
    fontColor: string = "#ff0000",
    fontSize = "30px"
  ) {
    let textObj = this.mAttachedScene.add.text(x, y, text, {
      fontFamily: "shrewsbury",
      fontSize: fontSize,
      color: fontColor,
      strokeThickness: 2,
      stroke: "#000000",
      shadow: {
        offsetX: 0,
        offsetY: 0,
        color: "#00000",
        blur: 4,
        stroke: true,
        fill: false,
      },
    });

    this.mAttachedScene.tweens.add({
      targets: textObj,
      y: y - 50,
      ease: "Cubic",
      duration: 1000,
    });
    this.mAttachedScene.tweens.add({
      targets: textObj,
      y: y - 60,
      ease: "Cubic",
      duration: 1000,
      onComplete: function () {
        textObj.destroy();
      },
    });

    // this.mAttachedScene.tweens.add({
    //     targets: textObj,

    //     ease: 'Linear',
    //     duration: 2000,
    //     delay: 200,
    //     yoyo: false,
    //     callbackScope: this,
    //     onComplete: function () {
    //         scene.tweens.add({
    //             targets: text,
    //             ease: 'Linear',
    //             duration: 2000,
    //             yoyo: false,
    //             callbackScope: this,
    //             onComplete: function () {
    //                 textObj.destroy();
    //             }
    //         });
    //     }
    // });
  }
}
